import { ApolloClient, InMemoryCache, from, ApolloLink } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { RestLink } from 'apollo-link-rest';
import config from 'src/config';
import { Auth } from 'src/config/amplify';
import TokenService from 'src/services/token-storage';

export enum IEndPoint {
  HIRE = 'hire',
  MANAGE = 'manage',
}

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.log(`GraphQL error --> Message:${message}, Location: ${locations}, Path: ${path}`);
    });
  }
  if (networkError) console.log(`Network Error --> ${networkError}`);
});

const authLink = setContext(async (_, previousContext) => {
  try {
    if (previousContext.skipAuth) {
      return { headers: { ...previousContext.headers } };
    }

    if (previousContext.userType === 'client') {
      const clientAccessToken = TokenService.getAccessToken();
      const clientRefreshToken = TokenService.getRefreshToken();
      return {
        headers: {
          ...previousContext.headers,
          authorization: clientAccessToken ? `Bearer ${clientAccessToken}` : '',
        },
        data: {
          refresh: clientRefreshToken,
        },
      };
    }

    const session = await Auth.currentSession();
    const token = session.getAccessToken().getJwtToken();
    const idToken = session.getIdToken().getJwtToken();

    return {
      headers: {
        ...previousContext.headers,
        authorization: token ? `Bearer ${token}` : '',
        idToken,
      },
    };
  } catch (error) {
    console.error('Auth Link Error -->', error);
    return {
      headers: { ...previousContext.headers },
    };
  }
});

const baseLink = ApolloLink.split(
  operation => operation.getContext().skipAuth || operation.getContext().endPoint === IEndPoint.MANAGE,
  createUploadLink({ uri: `${config.manageAppBaseUrl}graphql` }),
  createUploadLink({ uri: `${config.baseUrl}graphql` }),
);

const restLink = new RestLink({
  uri: config.manageAppBaseUrl,
  endpoints: {
    manage: config.manageAppBaseUrl || '',
    hire: config.baseUrl || '',
  },
});

const link = from([errorLink, authLink, restLink, baseLink]);

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link,
});

export default client;
